var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEProcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 48,
    viewBox: "0 0 181 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2628_7603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4766 34.6842L44.0436 24.0029",
    stroke: "url(#paint0_linear_2628_7603)",
    strokeWidth: 7.91209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0436 24.0026L37.4766 13.3213",
    stroke: "#00B4FF",
    strokeWidth: 7.91209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9678 24.0029H44.0425",
    stroke: "#00B4FF",
    strokeWidth: 7.91209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.752 4.40636C21.1234 4.11625 22.5344 3.95801 23.9981 3.95801C26.319 3.95801 28.5476 4.35361 30.6179 5.07889",
    stroke: "#00B4FF",
    strokeWidth: 7.91209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46057 33.8525C4.86497 30.9778 3.95508 27.6679 3.95508 24.1338C3.95508 18.5954 6.19684 13.5844 9.82321 9.95801",
    stroke: "#00B4FF",
    strokeWidth: 7.91209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5934 42.9379C28.523 43.6499 26.3076 44.0455 24 44.0455C20.4395 44.0455 17.1032 43.1225 14.2021 41.4873",
    stroke: "#00B4FF",
    strokeWidth: 7.91209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.389 28.179H68.9318C69.3802 29.7482 70.5011 30.5394 72.2285 30.5394C73.956 30.5394 74.0219 30.1702 74.4703 29.4845H79.3494C78.6241 32.5174 75.8022 34.4295 72.1626 34.4295C68.523 34.4295 67.8241 33.7043 66.3472 32.2801C64.8571 30.8559 64.1318 29.0098 64.1318 26.7284C64.1318 24.4471 64.8571 22.6405 66.2813 21.2163C67.7318 19.7922 69.6439 19.0669 71.978 19.0669C74.3121 19.0669 75.9208 19.7658 77.345 21.124C78.7692 22.4823 79.4681 24.2493 79.4681 26.4251C79.4681 28.601 79.4417 27.7834 79.3758 28.179H79.389ZM68.9055 25.3043H74.8791C74.6022 23.6691 73.6395 22.8515 71.9648 22.8515C70.2901 22.8515 69.3011 23.6691 68.9055 25.3043Z",
    fill: "#2C006A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5986 13.4771C93.1173 13.4771 95.1481 14.1496 96.6646 15.4814C98.1811 16.8133 98.9327 18.5672 98.9327 20.7825C98.9327 22.9979 98.1151 24.9628 96.48 26.3606C94.8712 27.7584 92.7217 28.4573 90.0316 28.4573H86.9459V34.088H82.5547V13.4771H90.6118H90.5986ZM90.4536 24.488C92.9063 24.488 94.6074 22.9979 94.6074 20.7957C94.6074 18.5935 92.9723 17.499 90.4536 17.499H86.9327V24.5012H90.4536V24.488Z",
    fill: "#2C006A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.658 21.2041C107.016 19.9645 108.718 19.3315 110.748 19.3315V23.3271C108.533 23.4195 106.845 24.1184 105.658 25.4239V34.0876H101.452V19.5689H105.658V21.2041Z",
    fill: "#2C006A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.544 21.4156C127.034 22.8397 127.76 24.6331 127.76 26.8353C127.76 29.0375 127.034 30.8969 125.544 32.3474C124.094 33.798 122.248 34.5233 120.032 34.5233C117.817 34.5233 115.944 33.798 114.454 32.3474C112.964 30.8969 112.239 29.0507 112.239 26.8353C112.239 24.62 112.964 22.8397 114.454 21.4156C115.944 19.9914 117.79 19.2661 120.032 19.2661C122.274 19.2661 124.094 19.9914 125.544 21.4156ZM123.606 26.8485C123.606 24.6727 122.182 23.0244 120.032 23.0244C117.883 23.0244 116.393 24.6595 116.393 26.8485C116.393 29.0375 117.843 30.7914 120.032 30.7914C122.221 30.7914 123.606 29.0639 123.606 26.8485Z",
    fill: "#2C006A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.933 28.3909H145.14C144.929 30.1843 144.138 31.6349 142.779 32.7557C141.421 33.8766 139.747 34.4173 137.834 34.4173C135.922 34.4173 133.773 33.692 132.283 32.2678C130.793 30.8173 130.041 28.9975 130.041 26.848C130.041 24.6986 130.793 22.8788 132.283 21.4546C133.773 20.0041 135.619 19.2788 137.834 19.2788C140.05 19.2788 141.408 19.859 142.779 20.9799C144.138 22.1008 144.929 23.525 145.14 25.3184H140.933C140.604 23.8942 139.443 23.0107 137.848 23.0107C136.252 23.0107 134.208 24.6722 134.208 26.8612C134.208 29.0502 135.659 30.6854 137.848 30.6854C140.037 30.6854 140.604 29.8414 140.933 28.4173V28.3909Z",
    fill: "#2C006A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.753 21.4156C162.243 22.8397 162.968 24.6331 162.968 26.8353C162.968 29.0375 162.243 30.8969 160.753 32.3474C159.302 33.798 157.456 34.5233 155.241 34.5233C153.025 34.5233 151.153 33.798 149.663 32.3474C148.173 30.8969 147.447 29.0507 147.447 26.8353C147.447 24.62 148.173 22.8397 149.663 21.4156C151.153 19.9914 152.999 19.2661 155.241 19.2661C157.482 19.2661 159.302 19.9914 160.753 21.4156ZM158.814 26.8485C158.814 24.6727 157.39 23.0244 155.241 23.0244C153.091 23.0244 151.601 24.6595 151.601 26.8485C151.601 29.0375 153.052 30.7914 155.241 30.7914C157.43 30.7914 158.814 29.0639 158.814 26.8485Z",
    fill: "#2C006A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.66 21.0332C179.847 22.3123 180.414 24.0002 180.414 26.1233V34.0881H176.208V26.4793C176.208 24.1716 175.06 22.9321 173.082 22.9321C171.104 22.9321 170.907 23.5387 169.904 24.7519V34.0881H165.698V19.5694H169.904V20.598C171.144 19.5958 172.542 19.1079 174.058 19.1079C175.575 19.1079 177.513 19.7409 178.66 21.02V21.0332Z",
    fill: "#2C006A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2628_7603",
    x1: 40.7601,
    y1: 38.6403,
    x2: 40.7601,
    y2: 20.0469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C006A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2628_7603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180.414,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEProcon);
export default __webpack_public_path__ + "static/media/logo-e-procon.9ff4dbfe91680f6b384d9416704afadd.svg";
export { ForwardRef as ReactComponent };